export default "__VITE_ASSET__6EEZ3aLe__"